const CLICKABLE = false;
const NOTCLICKABLE = true;

// Additional functionality for mobile accordion to integrate mobile and desktop views
export default class SpecsTabAccordion{
  constructor(accordionEventListener, tabSelector, activeTabClass){
    this.accordionEventListener = accordionEventListener;
    this.tabSelector = tabSelector;
    this.activeTabClass = activeTabClass;
    this.clickStatus = CLICKABLE;
  }

  initEventListeners(){
    // If the accordion is clicked in mobile view, this event listener changes things in desktop view
    this.accordionEventListener.forEach( (e) => {
      e.addEventListener('click', (event) => {
        const tabData = e.parentNode.getAttribute('data-tab-accordion-content');
        const tab = document.querySelector(`[data-tab="${tabData}"]`);

        if (this.clickStatus === NOTCLICKABLE) event.preventDefault();
        // Deactivates active tab class in desktop view
        else if (tab.classList.contains(this.activeTabClass)){
          this.deactiveTab(tab);
        } else { // Deactivates all active tab classes in desktop view since only one can be open at a time
          this.deactiveAllTabs();
          this.activateTab(tab);
        }
      });
    });
  }

  deactiveTab(element){
    element.classList.remove(this.activeTabClass);
  }

  deactiveAllTabs(){
    this.tabSelector.forEach( (e) => {
      e.classList.remove(this.activeTabClass);
    });
  }

  activateTab(element){
    element.classList.add(this.activeTabClass);
  }

  disableClick(){
    this.clickStatus = NOTCLICKABLE;
  }

  enableClick(){
    this.clickStatus = CLICKABLE;
  }
}
